import React from 'react';
import { CheckboxField } from 'lidya-common-components';

export const CheckBoxField = function () {
  return (
    <CheckboxField
      name="agreeTerms"
      validate={(val) => !val}
      required
      size={1}
      hideErrorMessage
    />
  );
};

CheckBoxField.propTypes = {};

export default CheckBoxField;
